const logoUrl = "https://storage.helloreaddy.io/project_files/8cf86b48-d09c-4ec8-816e-12bbed2b078b/1e3fa9b9-1413-4092-84fc-01303456e9e9_compressed_Biff-Digital-Logo.webp";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-10 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img src={logoUrl} alt="BIFF Digital - Growth & Campaign Agency" width="160" height="56" className="h-12 w-auto" />
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed mb-6 max-w-xs">
              Görünmek yetmez. Doğru algılanmak gerekir. Growth + Strategy + Execution modeliyle markaların büyüme sistemlerini kuruyoruz.
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/company/biff-digital"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 bg-background-200 rounded-xl flex items-center justify-center hover:bg-primary-500/10 transition-colors"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-foreground-300" />
              </a>
              <a
                href="https://www.youtube.com/@Biff-Digital"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 bg-background-200 rounded-xl flex items-center justify-center hover:bg-primary-500/10 transition-colors"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-foreground-300" />
              </a>
              <a
                href="https://www.instagram.com/biffdigital"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 bg-background-200 rounded-xl flex items-center justify-center hover:bg-primary-500/10 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-foreground-300" />
              </a>
            </div>
          </div>

          {/* Hizmetler */}
          <div>
            <h3 className="text-foreground-50 font-bold text-sm mb-4 uppercase tracking-wider">Hizmetler</h3>
            <ul className="space-y-2.5">
              <li><a href="/hizmetler/performans-pazarlama" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Performans Pazarlama</a></li>
              <li><a href="/hizmetler/seo" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">SEO & GEO</a></li>
              <li><a href="/hizmetler/marka-stratejisi" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Marka Stratejisi & Branding</a></li>
              <li><a href="/hizmetler/web-gelistirme" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Web Geliştirme & Yazılım</a></li>
              <li><a href="/hizmetler/noropazarlama" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Nöropazarlama</a></li>
              <li><a href="/hizmetler/kampanya-yonetimi" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Kampanya & İtibar</a></li>
            </ul>
          </div>

          {/* Sektörler + Şirket */}
          <div>
            <h3 className="text-foreground-50 font-bold text-sm mb-4 uppercase tracking-wider">Sektörler</h3>
            <ul className="space-y-2.5 mb-8">
              <li><a href="/sektorler/e-ticaret-dijital-pazarlama" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">E-Ticaret</a></li>
              <li><a href="/sektorler/endustriyel-b2b-pazarlama" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Endüstriyel & B2B</a></li>
              <li><a href="/sektorler/ihracat" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">İhracat</a></li>
              <li><a href="/sektorler/siyasi-kampanya" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Siyasi Kampanya</a></li>
            </ul>

            <h3 className="text-foreground-50 font-bold text-sm mb-4 uppercase tracking-wider">Şirket</h3>
            <ul className="space-y-2.5">
              <li><a href="/ankara-dijital-pazarlama-ajansi" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Hakkımızda</a></li>
              <li><a href="/basarili-dijital-projeler" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">Vakalar</a></li>
              <li><a href="/dijital-pazarlama-blog" className="text-sm text-foreground-500 hover:text-foreground-200 transition-colors">İçgörüler</a></li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h3 className="text-foreground-50 font-bold text-sm mb-4 uppercase tracking-wider">İletişim</h3>
            <div className="space-y-3 text-sm text-foreground-500">
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-foreground-400" />
                +90 555 710 1968
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-400" />
                info@biffdigital.com
              </p>
              <p className="flex items-start gap-2">
                <i className="ri-map-pin-line text-foreground-400 mt-0.5" />
                Söğütözü Cad. No: 2 Koç Kuleleri C Blok 17 Çankaya/Ankara
              </p>
            </div>
            <div className="mt-4 text-sm text-foreground-500">
              <p className="font-semibold text-foreground-400 mb-1">Çalışma Saatleri</p>
              <p className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 rounded-full bg-green-500" />
                Pazartesi - Cuma: 09:00 - 18:00
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-background-200/60 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-foreground-600">
            &copy; 2026 Biff Digital. Tüm hakları saklıdır.
          </p>
          <div className="flex gap-6 text-xs text-foreground-600">
            <a href="/gizlilik-politikasi" className="hover:text-foreground-400 transition-colors">Gizlilik Politikası</a>
            <a href="/kvkk" className="hover:text-foreground-400 transition-colors">KVKK</a>
            <a href="/cerez-politikasi" className="hover:text-foreground-400 transition-colors">Çerez Politikası</a>
          </div>
        </div>
      </div>
    </footer>
  );
}